import { optionalDate, validOptionalDate } from '@/utils/schemas'
import { endOfDay, startOfDay } from 'date-fns'
import { z } from 'zod'
import { ServiceType } from '../offerings/offering'
import { DocType } from '../shared'
import { DeathRelationship, DeathState } from './deathData'

const validateDocNumber = (val: any) => {
  if (val !== undefined && val !== "") {
    if (val.length < 7) {
      return false
    }
    const num = parseInt(val);
    return isNaN(num) || (!isNaN(num) && num <= 999999999);
  }
  return true
}

export const deathDataSchema = (serviceType: string) => {
  const schema = z.object({
    name: z.string().min(1, 'El nombre es requerido').max(100, 'El nombre es muy largo'),
    docType: z.enum(Object.values(DocType)).optional(),
    docNumber: z.string().optional().refine((val) => validateDocNumber(val),
      'Si ingresas un número, el número de documento debe tener al menos 7 dígitos y ser válido'),
    birthDate: validOptionalDate,
    deathDate: validOptionalDate,
    state: z.enum(Object.values(DeathState)).optional(),
    notes: z.string().max(255).optional(),
    cremationDate: optionalDate,
    intermentDate: optionalDate,
    disintermentDate: optionalDate,
    reductionDate: optionalDate,
    relationshipWithDeceased: z.enum(Object.values(DeathRelationship), { message: 'Debes seleccionar un parentesco con el fallecido' }).optional().nullable(),
    thumbLevel: z.string().optional(),
    entryNumber: z.string().optional(),
    volume: z.string().optional(),
    year: z.string().optional(),
    leaf: z.string().optional(),
    office: z.string().optional(),
    mortuary: z.string().optional(),
    medicOfDeceased: z.string().optional(),
    deathCertificateAuthorization: z.string().optional(),
    transferredTo: z.string().optional(),
  })

  if (serviceType === ServiceType.CREMACIONES) {
    return schema.extend({
      deathDate: z.date({ message: 'La fecha de defunción es requerida' }),
      cremationDate: z.date().nullable().optional()
    }).refine(data =>
      (data.deathDate && data.birthDate) ? endOfDay(data.deathDate).getTime() > startOfDay(data.birthDate).getTime() : true
      , { path: ['birthDate'], message: 'La fecha de nacimiento debe ser anterior a la fecha de defunción' })
  }

  if (serviceType === ServiceType.PARCELAS) {
    return schema.extend({
      intermentDate: z.date().optional(),
      thumbLevel: z.number({ message: 'El nivel es requerido' }).min(1).max(3),
    })
  }

  return schema
}